import styled from 'styled-components';
import { List } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { ArticlesIcon } from '../../../icons';
import { RightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
const CardContainer = styled.div`
  min-width: 350px;
  max-width: 400px;
  min-height: 300px;
  margin-left: 20px;
  padding: 20px;
  background-color: #0e0e0e;
  border: 1px solid #0e0e0e;
  box-shadow: 0 2px 10px #0e0e0e;
  border-radius: 6px;
  @media screen and (max-width: 1440px) {
    width: 100%;
  }
  @media screen and (max-width: 768px) {
    max-width: 100%;
    margin-left: 0;
  }
`;

const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  color: #fff;
`;

const ArticlesLink = styled.div`
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 15px;
  ::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 6px;
    height: 6px;
    border-radius: 50%;
    ${(props) =>
      props.index > 2
        ? 'background-color: gray;'
        : 'background-color: #18eac4;'}
  }
`;

const Card = ({ children, data, loading }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <CardContainer>
      <Title>
        <div
          style={{
            fontSize: '18px',
            lineHeight: '18px',
            fontWeight: '600',
          }}
        >
          <ArticlesIcon />
          {t('home_articles')}
        </div>
        <RightOutlined
          width={'18px'}
          height={'18px'}
          style={{
            marginTop: '5px',
          }}
          onClick={() => {
            navigate('/articles');
          }}
        />
      </Title>
      <List
        dataSource={data}
        loading={loading}
        renderItem={(item) => (
          <List.Item
            style={{
              border: 'none',
              fontFamily: 'HelveticaNeue'
            }}
          >
            <ArticlesLink index={item.key}>
              <Link
                to={'/articles/detail/' + item.id}
                style={{
                  color: '#fff',
                }}
              >
                {item.title}
              </Link>
            </ArticlesLink>
          </List.Item>
        )}
      />
    </CardContainer>
  );
};

export default Card;
